<template>
  <div class="modal-head">
    <div class="logo">
      <img class="logo" src="~@/assets/imgs/logo-weis.svg" />
    </div>
    <div class="text">
      <div>
        <div>TON DESIGN</div>
        <div><strong>SI OUI, ALORS WINSTON</strong></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalHead',
}
</script>
<style lang="scss" scoped>
.modal-head {
  display: flex;
  justify-content: space-between;
  width: 100%;
  img svg {
    fill: #ffffff;
  }
  .logo {
    flex: 1;
    padding: 16px;
  }
  .text {
    float: right;
    padding-top: 40px;
    > div {
      padding-right: 50px;
    }
    > div > div {
      font-weight: normal;
      font-size: 35px;
      margin: 0;
      padding: 0;
      line-height: 32px;
      text-align: left;
      color: #ffffff;
    }
  }
}
</style>
